// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","footerLinks":"Footer_footerLinks__HgE5R"};